module.exports = function() {
  return new Worker(__webpack_public_path__ + "770399708e74ac42e1f4.worker.js");
};